module.exports = __webpack_public_path__ + "static/media/canYa.2335edc9.png";